<template>
  <div class="input-number">
    <button
      type="button"
      class="input-number__btn"
      @click="minus"
      :class="{ 'input-number__btn_inactive': isMinusDisabled }"
    >
      <icon name="minus" />
    </button>
    <input
      type="text"
      v-model="currentValue"
      class="n-input__field"
      @focus="$event.target.select()"
      @blur="handleBlur()"
      @input="handleBlur"
      :disabled="disabled"
    />
    <button
      class="input-number__btn"
      type="button"
      @click="plus"
      :class="{
        'input-number__btn_inactive': isPlusDisabled || externalPlusDisable
      }"
    >
      <icon name="plus" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    min: {
      type: Number,
      default: Number.MIN_SAFE_INTEGER
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    value: {
      type: Number,
      default: 0
    },
    externalPlusDisable: {
      type: Boolean,
      default: false
    },
    initValue: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentValue: this.value,
      debounce: null
    };
  },

  created() {
    if (parseInt(this.currentValue) < this.min) {
      this.currentValue = this.min;
    }
  },

  mounted() {
    if (this.initValue) {
      this.currentValue = this.initValue;
    }
  },

  methods: {
    handleBlur($event) {
      let number = this.min || 0;
      try {
        number =
          parseInt($event ? $event.target.value : this.currentValue + "") || 0;
      } catch (e) {
        console.error(e);
      }
      if (number < this.min) number = this.min;
      if (number > this.max) number = this.max;
      this.currentValue = number;
    },
    plus() {
      if (this.isPlusDisabled || this.externalPlusDisable) {
        return;
      }

      this.currentValue++;
    },

    minus() {
      if (this.isMinusDisabled) {
        return;
      }

      this.currentValue--;
    }
  },

  computed: {
    isPlusDisabled() {
      return this.disabled || this.currentValue >= this.max;
    },

    isMinusDisabled() {
      return this.disabled || this.currentValue <= this.min;
    }
  },

  watch: {
    value(value) {
      this.currentValue = value;
    },

    currentValue(v) {
      this.$emit("input", v);
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$emit("debounceInput", v);
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.input-number {
  display: flex;
  width: 100px;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  border-radius: 2px;
  background-color: #ffffff;
  border: 1px solid #cdced0;
  box-sizing: border-box;

  &__btn {
    @include button-clean();
    display: flex;
    width: 40px;
    height: 100%;
    padding: 10px;

    &:not(&_inactive):hover {
      background: var(--gray, #f9f9f9);
    }

    .svg-icon {
      height: 12px;
      width: 13px;

      color: #0070d2;

      margin: auto;

      rect {
        fill: currentColor;
      }
    }

    &_inactive {
      pointer-events: none;

      .svg-icon {
        //color: #a3a8b3;
        filter: grayscale(1);
      }
    }
  }

  & > input {
    background: none;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    cursor: text;
    text-align: center;
    border: none;
    appearance: none;
  }
}
</style>
